<div class="product-card" [ngClass]="{ 'reduced': mode === 'reduced', 'mind': productType === 'MIND', 'movel': productType === 'MOVEL', 'no-image': !showImage }">
  <div class="product-card__image" *ngIf="showImage">
    <img [src]="imageUrl | imageFallback" [alt]="title" (error)="onImageError($event)" />
  </div>

  <div class="product-card__content">
    <div class="product-card__container">
      <div class="product-card__header">
        <div class="product-card__heading">
          <span class="product-card__badge" *ngIf="badge">{{ badge }}</span>
          <h2 class="product-card__title">{{ title }}</h2>
        </div>
        <!-- <button class="product-card__info-button">
          <i class="material-icons">info</i>
        </button> -->
        </div>
      <p class="product-card__description">{{ description | innerHtml }}</p>
    </div>

    <div class="product-card__plan-selector" *ngIf="mode === 'full' && (plans?.length ?? 0) > 0">
      <select [(ngModel)]="selectedPlan" (ngModelChange)="onPlanChange()" (focus)="onSelectFocus()"
        (blur)="onSelectBlur()" class="product-card__select" [class.error]="showSelectError"
        [class.active]="selectedPlan || isSelectFocused">
        <option [ngValue]="null" disabled>{{ 'components.productCard.choosePlan' | i18n }}</option>
        <option *ngFor="let plan of plans" [ngValue]="plan">
          {{ plan.name }}
        </option>
      </select>
    </div>

    <div class="product-card_infoprice" [ngClass]="{ 'reduced': mode === 'reduced' }">
      <div class="product-card_headerPrice">{{ getPriceLabelKey() | i18n }}</div>
      <div class="product-card__price">
        <span
          class="product-card__badge"
          *ngIf="showMindPromotion"
        >{{ 'components.productCard.ofertaClaro' | i18n }}</span>
        <div class="product-card__price-label-container">
          <div class="product-card__price-label" *ngIf="showPriceLabel">
            {{ 'pages.home.priceLabel' | i18n }}
          </div>
        </div>
        <div class="product-card__price-value">
          <span class="currency">R$</span>
            <span class="amount font-highlight">{{ formatPrice(displayPrice).split(',')[0] }}</span>
            <span class="cents">,{{ formatPrice(displayPrice).split(',')[1] }}</span>
        </div>
        <div
          class="product-card__price-from"
          *ngIf="showMindPromotion"
        >
          {{ 'components.productCard.fromPriceMonthly' | i18n: { price: mindOriginalPriceFormatted } }}
        </div>
        <div
          class="product-card__price-promo"
          *ngIf="showMindPromotion"
        >
          <span>{{ mindPromoDurationKey | i18n: mindPromoDurationParams }}</span>
          <span>{{ 'components.productCard.promoAfterMonthly' | i18n: mindPromoAfterParams }}</span>
        </div>
        <div class="product-card__price-period" [class.hidden]="!shouldShowPlanLabel()">
          {{ planLabel | i18n}}
        </div>
      </div>
    </div>

    <!-- Seletor de quantidade opcional -->
    <div class="product-card__quantity" *ngIf="mode === 'full' && showQuantitySelector && productType !== 'MIND' && productType !== 'MOVEL'">
      <div class="quantity-container">
        <button class="quantity-button" (click)="decrement()" [disabled]="quantity <= 1">−</button>
        <span class="quantity-value">{{ quantity.toString().padStart(2, '0') }}</span>
        <button class="quantity-button" (click)="increment()">+</button>
      </div>
    </div>

    <span
      *ngIf="mode === 'full' && showAddToCart"
      class="product-card__add-button-wrap"
      [attr.title]="
        productType === 'MIND' && mindCategoryLocked
          ? ('components.productCard.mindCategorySingleLimitHint' | i18n)
          : null
      "
    >
      <button
        type="button"
        class="product-card__add-button"
        (click)="onAddToCart()"
        [disabled]="(!buyNowLink && !selectedPlan && (plans.length > 0)) || mindCategoryLocked"
      >
        <i class="material-icons" *ngIf="!buyNowLink">shopping_cart</i>
        {{ addToCartTextOverride || ('components.productCard.addToCart' | i18n) }}
      </button>
    </span>

    <button *ngIf="mode === 'reduced'" type="button" class="product-card__add-button" (click)="onLearnMoreClick($event)">
      {{ learnMoreTextOverride || ('components.productCard.learnMore' | i18n) }}
    </button>

    <a
      *ngIf="mode === 'full' && showLearnMore"
      href="#"
      class="product-card__learn-more"
      style="cursor: pointer"
      (click)="onLearnMoreClick($event)"
    >
      {{ learnMoreTextOverride || ('components.productCard.learnMore' | i18n) }}
    </a>
  </div>
</div>